import App from './App'

window.addEventListener('load', () => {
    // eslint-disable-next-line no-new
    new App()
})



// WEBPACK FOOTER //
// ./scripts/main.js